/**
 * @generated SignedSource<<6144c91b0940db9797b1942ed763edb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaFragment_facility$data = {
  readonly club: {
    readonly slug: string;
  } | null | undefined;
  readonly durations: ReadonlyArray<number | null | undefined> | null | undefined;
  readonly id: string;
  readonly memberBookingWindowDays: number | null | undefined;
  readonly minMaxGroupSize: {
    readonly max: number | null | undefined;
    readonly min: number | null | undefined;
  } | null | undefined;
  readonly startEndTime: {
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DurationBasedAgendaFragment_facility";
};
export type DurationBasedAgendaFragment_facility$key = {
  readonly " $data"?: DurationBasedAgendaFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityStartEndTime",
      "kind": "LinkedField",
      "name": "startEndTime",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberBookingWindowDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "bookingType",
          "value": "STANDARD"
        }
      ],
      "concreteType": "GroupSize",
      "kind": "LinkedField",
      "name": "minMaxGroupSize",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "min",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "max",
          "storageKey": null
        }
      ],
      "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "5eedfd3e67860e3456ac1bbf7f24bd41";

export default node;
